import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, HostListener, Inject, Renderer2 } from '@angular/core';
import { TabItems } from "../../dashboard/_services/tab.service";
import { BusesTabItems } from "../../dashboard/_services/tab.service";
import { SchoolManagementTabItems } from "../../dashboard/_services/tab.service";
import { DataManagementTabItems } from "../../dashboard/_services/tab.service";
import { AppointmentsTabItems } from "../../dashboard/_services/tab.service";
import { Router } from '@angular/router';
import { UserService } from 'src/app/_services/user.service';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Subject, Subscription, forkJoin, take, takeUntil } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { AmplitudeService } from 'src/app/_services/amplitude.service';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { BusStudentsService } from 'src/app/buses/_services/bus-students.service';
import { MetaDataService } from 'src/app/_services/meta-data.service';
import { TabSyncService } from 'src/app/_services/tab-sync.service';
declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, AfterViewInit {
  @ViewChild('en') en: ElementRef;
  @ViewChild('ar') ar: ElementRef;
  @ViewChild('lng') lng: ElementRef;


  tabs = [];
  BusesTabItems = [];
  SchoolManagementTabItems = [];
  DataManagementTabItems = [];
  AppointmentsTabItems = [];
  activeTab: string;
  moduleName: string;
  userId;
  currentUserKeys = ['name', 'image_path', 'gender', 'national_id', 'country_code', 'phone', 'email'];
  currLang;
  schoolImg: string;
  schoolName: string;
  enableVoiceCalling: any = true;
  statusCalling;
  lngFlag: string;
  loginAs;
  loggedInUser;
  loginName;
  direction;
  initialLoading: boolean;
  pendingRequestsCount: number = 0;
  editRequestsCount: number = 0;
  earlyDismissalRequestsCount: number = 0;
  pendingRequestsFlag: boolean;
  toggleExcel: any = '';
  toggleQr: any = '';
  toggleApproveAll: any = '';
  toggleUpload: any = '';
  uploadType: any = '';
  uploadErrorsUrl: any = '';
  toggleBusEnrollAlert: any = '';
  excelFileUrl;
  qrFileUrl;
  timeOut;
  elem: any;
  baseUrl = environment.img_url;
  schools: any = []
  lastShcoolSelectedId;
  failedRequestsCount = 15


  selectedSchool: any;
  selectedSchoolLabel: string;
  selectedSchoolImg: any;
  sideBarWidth;
  showBusTabs;
  isSmallScreen: boolean = false;
  destroy$ = new Subject<void>();
  busEnrollSucessCount = 0;
  busEnrollFailedCount = 0;
  toggleBulkBusEnrollAlert: any = '';
  bulkBusEnrollSucessCount = 0;
  bulkBusEnrollFailedCount = 0;
  busEnrollType: 'single' | 'bulk' = 'single';
  toggleBulkStudentsUpdateAlert: any = '';
  bulkStudentsUpdateCompleted: boolean = false;
  bulkStudentsSuccessCount: number = 0;
  callingScreenBeta;
  toggleBulkStudentsImportAlert: any = '';
  bulkStudentsImportCompleted: boolean = false;
  bulkImportStudentsSuccessCount: number = 0;
  togglePioneerSyncAlert: 'idle' | 'syncing' | 'ready' = 'idle';
  @HostListener('window:resize', [])
  onResize() {
    this.checkScreenSize();
  }


  constructor(private router: Router, private userService: UserService, private translate: TranslateService, private dataService: DataService, private globalService: GlobalService, private location: Location, private http: HttpClient, private cdr: ChangeDetectorRef, private renderer: Renderer2, private el: ElementRef, private amplitudesService: AmplitudeService, private busService: BusStudentsService, private metaDataService: MetaDataService,
    private tabSyncService: TabSyncService,
    @Inject(DOCUMENT) private document: any) {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)layout_(f)getLang_(L)82' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.translate.onLangChange.pipe(take(1)).subscribe(res => {
      //console.log('(c)layout_(f)translateOnChange_(L)87' , res);
      this.currLang = res.lang
    });
  }
  ngOnInit() {
    this.checkScreenSize();
    this.elem = document.documentElement;
    this.globalService.getInitialLoading().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)layout_(f)getInitialLoading_(L)96' , res);
      let reloadFlag = localStorage.getItem("relaod");
      if (reloadFlag == 'false') {
        this.initialLoading = res;
      }
    })
    this.loginAs = localStorage.getItem('loginAs');

    this.loginName = localStorage.getItem('userName');
    this.statusCalling = localStorage.getItem('statusCalling');
    // this.enableVoiceCalling = localStorage.getItem('voiceCalling');
    // this.globalService.getLang().subscribe(lng => {
    //   this.currLang = lng;
    //   this.translate.use(this.currLang);
    // });
    // tab.name.includes(activeTab.substring(0,7))
    this.enableVoiceCalling = localStorage.getItem('voiceCalling');
    if (this.enableVoiceCalling == "false") {
      this.enableVoiceCalling = false;
    } else {
      this.enableVoiceCalling = true;
    }
    // this.enableVoiceCalling = false;
    localStorage.setItem('voiceCalling', this.enableVoiceCalling);

    this.schoolName = localStorage.getItem('schoolName');
    this.schoolImg = environment.img_url + localStorage.getItem('schoolImage');
    this.moduleName = window.location.pathname.split('/')[1];
    this.tabs = TabItems;
    // this.dataService.getIsBeta().subscribe(res=>{
    //   if(res){
    //     this.tabs = TabItems
    //   }
    //   else {
    //     this.tabs = TabItems.filter(tab => tab.name != 'edit requests');
    //   }
    // })
    this.BusesTabItems = BusesTabItems;
    this.SchoolManagementTabItems = SchoolManagementTabItems;
    this.DataManagementTabItems = DataManagementTabItems;
    this.AppointmentsTabItems = AppointmentsTabItems;
    this.activeTab = window.location.pathname.split('/')[2];
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)layout_(f)routerEvents_(L)145' , res);
      if (res.url) {
        this.activeTab = res.url.split('/')[2];
      }
    })
    this.userId = localStorage.getItem('userId')
    // this.userService.getProfile(this.userId).subscribe((res: any) => {
    //   for (const key of this.currentUserKeys) {
    //     this.dataService.currentUser[key] = res[key];
    //   }
    //   this.dataService.currentUser['role_type'] = res.roles.find(role => role.name == localStorage.getItem('loginAs')).name;
    // })


    // this.dataService.getRequestsFlag().subscribe(res=>{
    //   this.pendingRequestsFlag =res;
    // })

    this.dataService.getRequestsCounter().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)layout_(f)getRequestsCounter_(L)166' , res);
      this.pendingRequestsCount = res;
      // this.cdr.detectChanges();
    })

    this.dataService.getEditRequestsCounter().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)layout_(f)getEditRequestsCounter_(L)172' , res);
      this.editRequestsCount = res;
      // this.cdr.detectChanges();
    })

    this.dataService.getEarlyDismissalRequestsCounter().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)layout_(f)getEarlyDismissalRequestsCounter_(L)178' , res);
      this.earlyDismissalRequestsCount = res;
      // this.cdr.detectChanges();
    })


    this.getAllRequests();
    this.metaDataService.start();

    // real time notifications
    this.globalService.getExportAlert().subscribe(res => {
      this.toggleExcel = res;
      this.toggleColors(res, 'excel');
    })

    this.globalService.getPrintQrAlert().subscribe(res => {
      this.toggleQr = res;
      this.toggleColors(res, 'qr');
    })

    this.globalService.getApproveAllRequests().subscribe(res => {
      this.toggleApproveAll = res;
      this.toggleColors(res, 'approveAll');
    })

    this.globalService.getUploadSheet().subscribe(res => {
      this.toggleUpload = res;
      this.toggleColors(res, "upload")
    })


    // export excel and print qr channel
    this.globalService.channel.bind(`excel.exported`, data => {
      if (data) {
        if (data.type == 'parents_qr_code' || data.type == 'students_qr_code') {
          this.globalService.setPrintQrAlert('ready');
          this.globalService.getPrintQrAlert().subscribe(res => {
            this.toggleQr = res;
            this.toggleColors(res, 'qr');
            this.qrFileUrl = data.url;
          })
        }
        else {
          this.globalService.setExportAlert('ready');
          this.globalService.getExportAlert().subscribe(res => {
            this.toggleExcel = res;
            this.toggleColors(res, 'excel');
            this.excelFileUrl = data.url;
          })
        }
        // this.toggleExcel = null;
        // this.toggleExcel = 'ready';
        // this.toggleColors('ready');
      }
    });

    // approve all requests channel
    this.globalService.channel.bind(`studentEditRequsts.approvedAll`, res => {
      if (res) {
        if (res?.data?.failed_count > 0) {
          this.globalService.setApproveAllRequests('failed');
          this.failedRequestsCount = res?.data?.failed_count;
          this.globalService.getApproveAllRequests().subscribe(res => {
            this.toggleApproveAll = res;
            this.toggleColors(res, 'approveAll');
          })
        }
        else {
          let currentUrl = this.router.url;
          this.globalService.setApproveAllRequests('ready');
          this.globalService.getApproveAllRequests().subscribe(res => {
            this.toggleApproveAll = res;
            this.toggleColors(res, 'approveAll');
          })
          if (currentUrl.split('/').pop() == "edit-requests") {
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate([currentUrl]);
              setTimeout(() => {
                this.globalService.setApproveAllRequests('');
              }, 2000);
            });
          }
        }
      }
    });

    // upload channel
    this.globalService.channel.bind(`file.imported`, res => {
      this.uploadType = "";
      this.uploadType = res?.type;
      if (res) {
        if (res?.status == "partially_failed") {
          this.globalService.setUploadSheet('failed');
          // reset the upload errors url to set it again when btn clicked 
          // this.globalService.setUploadErrorsUrl('');
          this.uploadErrorsUrl = res?.url;
          this.globalService.getUploadSheet().subscribe(res => {
            this.toggleUpload = res;
            this.toggleColors(res, 'upload');
          })
        }
        else if (res?.status == "completed") {
          this.globalService.setUploadSheet('ready');
          this.globalService.getUploadSheet().subscribe(res => {
            this.toggleUpload = res;
            this.toggleColors(res, 'upload');
          })
        }
      }
    });

    // refresh all schools channel
    this.globalService.refreshChannel.bind(`refresh-all-schools`, res => {
      window.location.reload();
    });

    // refresh school by id channel
    this.globalService.refreshChannel.bind(`refresh-school-${localStorage.getItem('schoolId')}`, res => {
      window.location.reload();
    });

    // bus enroll channel
    this.globalService.getBusEnrollNotificationState().subscribe(res => {
      // console.log('bulk enroll notification state', res);
      this.toggleBusEnrollAlert = res;
      this.toggleColors('preparing', 'upload');
    })

    this.busService.getEnrollDetails().subscribe(res => {
      this.busEnrollType = res?.enroll_type == 'bulk_import' ? 'bulk' : 'single';
      this.busEnrollFailedCount = res?.fail_count + res?.ignored_count;
      this.busEnrollSucessCount = res?.success_count;
    })


    this.globalService.busEnrollChannel.bind(`bus.enrolled`, res => {
      if(res?.enroll_type == 'bulk_import'){
        this.busEnrollType = 'bulk';
        this.globalService.setNotifyViewWithBulkEnrollState('finshed-with-details');
        this.globalService.setBulkEnrollNotificationState('not-uploading');
        // this means that the bulk enroll is done and the user can go to the next step , so we need to set the auto bus enroll to false to avoid auto enroll when user retry the flow
        this.globalService.setAutoBusEnroll(false);
      }
      this.busEnrollFailedCount = res?.fail_count + res?.ignored_count;
      this.busEnrollSucessCount = res?.success_count;
      this.globalService.setBusEnrollNotificationState('ready');
      this.busService.setEnrollDetails(res);
    });

    this.globalService.getBulkEnrollNotificationState().subscribe(res => {
      // console.log('bulk enroll notification state', res);
      this.toggleBulkBusEnrollAlert = res;
      this.toggleColors(this.toggleBulkBusEnrollAlert, 'bus-bulk-enroll');
    })
    this.globalService.bulkBusEnrollChannel.bind(`bus.import.status`, result => {
      let local_notification_state = 'not-uploading';
      if (result) {
        if (result?.event_type == "validation_completed") {
          localStorage.setItem('bulkBusEnrollBatchId', result?.batch_id);
          if (result?.status_flags) {
            local_notification_state = result?.status_flags?.has_errors ? 'finshed-with-errors' : 'finished';
          }
          else {
            local_notification_state = 'not-uploading';
          }
          this.globalService.setBulkEnrollNotificationState(local_notification_state);
          this.globalService.setNotifyViewWithBulkEnrollState(local_notification_state);
          this.globalService.setBulkBusEnroll(result);
        }
        else if (result?.event_type == "processing_failed") {
          this.busService.setEnrollErrors(result?.additional_data?.error);
          this.router.navigate(['/buses/enroll-errors']);
          this.globalService.setBulkEnrollNotificationState('not-uploading');
          this.globalService.setNotifyViewWithBulkEnrollState('not-uploading');
          this.globalService.setBulkBusEnroll('');
        }
      }
    });

    this.globalService.tripAssignmentChannel.bind(`trip.assignment.status`, result => {
    });

    // bulk students update channel
    this.globalService.getBulkStudentsUpdateNotificationState().subscribe(res => {
      this.toggleBulkStudentsUpdateAlert = res;
      this.toggleColors(this.toggleBulkStudentsUpdateAlert, 'bulk-students-update');
    })

    this.globalService.getBulkStudentsImportNotificationState().subscribe(res => {
      this.toggleBulkStudentsImportAlert = res;
      // console.log('import alert layout state',this.toggleBulkStudentsImportAlert)
      this.toggleColors(this.toggleBulkStudentsImportAlert, 'bulk-students-import');
    })

    this.globalService.getPioneerSync().pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.togglePioneerSyncAlert = data?.state || 'idle';
    })

    this.globalService.bulkStudentsUpdateChannel.bind(`bulk.import.status`, result => {
      // Debug: pair the received payload with the channel it actually arrived on and this tab's
      // own schoolId - if `channel` here doesn't match `bulk_import_${schoolId}`, or the payload's
      // batch/school doesn't belong to schoolId, the backend broadcast to the wrong channel.
      console.log('[Pusher] bulk.import.status received', {
        channel: this.globalService.bulkStudentsUpdateChannel.name,
        schoolId: localStorage.getItem('schoolId'),
        result
      });
      // pioneer sync shares the student_import import_type, so it must be checked before the switch below
      if (result?.event_type === 'pioneer_sync_completed') {
        console.log('Pioneer sync results', result);
        this.globalService.setPioneerSync({ state: 'ready', result });
        return;
      }
      switch(result?.import_type){
        case 'student_update':
          this.bulkStudentUpdateRealTimeHandler(result);
          break;
        case 'student_import':
          this.bulkStudentImportRealTimeHandler(result);
          break;
      }
    });




    /**
     * SCHOOL SELECTION FEATURE - LAYOUT INITIALIZATION
     * 
     * For users with admin/manager roles, we need to:
     * 1. Get the list of schools from the data service
     * 2. Process and filter schools to show only those where user has admin/manager roles
     * 3. Select the appropriate school (either from localStorage or default to first)
     * 
     * This runs on component initialization and also when navigating between pages.
     * The dataService.getSchoolInfo() returns schools that were stored during getAllRequests().
     * 
     * Note: This subscription may run before getAllRequests() completes, so it might not
     * have data initially. The getAllRequests() method also calls getSchools() directly
     * with fresh API data, which is the primary source of truth.
     */
    if (this.loginAs == "school_admin" || this.loginAs == "manager") {
      this.dataService.getSchoolInfo()?.subscribe(res => {
        if (!!res) {
          this.getSchools(res)
        }
      })
    }

    /**
     * SCHOOL SELECTION FEATURE - TEACHER / SUPERVISOR
     *
     * Same restore-on-navigation flow as admin/manager above, but delegated to
     * getSchoolsForObserver() which filters by the teacher/supervisor role (and does
     * NOT touch loginAs). Keeps the dropdown populated when moving between pages
     * without a full reload (getAllRequests() only rebuilds it on a hard reload).
     */
    if (this.loginAs == "teacher" || this.loginAs == "supervisor") {
      this.dataService.getSchoolInfo()?.subscribe(res => {
        if (!!res) {
          this.getSchoolsForObserver(res)
        }
      })
    }

    this.dataService.getIsBusBeta()?.subscribe(res => {
      this.showBusTabs = res;
    })
    this.dataService.getIsCallingScreenBeta()?.subscribe(res => {
      this.callingScreenBeta = res;
    })
  }

  checkScreenSize() {
    this.isSmallScreen = window.innerWidth < 1232;
  }

  /**
   * SCHOOL SELECTION FEATURE - HANDLE SCHOOL DROPDOWN SELECTION
   * 
   * When a user selects a different school from the dropdown:
   * 1. Store the selected school ID in localStorage for persistence
   * 2. CRITICAL: Update loginAs to match the user's role in the selected school
   *    - A user may have 'school_admin' role in School A and 'manager' role in School B
   *    - When switching schools, we must update loginAs to reflect the correct role
   *    - This prevents permission mismatches and ensures proper access control
   * 3. Navigate to dashboard and reload to apply the new school context
   * 
   * Why role synchronization is important:
   * - The loginAs value is used throughout the app to determine permissions and UI visibility
   * - If a user selects a school where they have a different role, the app must reflect that
   * - Example: User logs in as 'manager' but selects School A where they're 'school_admin'
   *   → loginAs must be updated to 'school_admin' to show correct permissions
   * 
   * @param event - The selected school ID from the dropdown
   */
  async onSelectionChange(event) {
    // Switching reloads the user's other open tabs, so ask first when there are any.
    // On cancel put the dropdown back on the current school; nothing has been written yet.
    if (!(await this.tabSyncService.confirmSchoolSwitch())) {
      this.selectedSchool = this.schools.find(school => school.value == localStorage.getItem('schoolId'))?.value;
      return;
    }

    // Store the selected school ID for persistence across page reloads
    localStorage.setItem('lastShcoolSelectedId', event);
    localStorage.setItem('schoolId', event);

    /**
     * TEACHER / SUPERVISOR PATH
     *
     * Teachers and supervisors switch schools from the calling screen (their home screen)
     * and have no access to the dashboard. So we must NOT navigate to 'dashboard/students';
     * we simply reload in place to re-initialize every component with the new school context.
     *
     * We also skip the admin/manager role synchronization below on purpose: the logged-in
     * role never changes when a teacher/supervisor moves between their own schools (the
     * dropdown only lists schools where they hold that same role), so loginAs stays as-is.
     */
    if (this.loginAs === 'teacher' || this.loginAs === 'supervisor') {
      window.location.reload();
      return;
    }

    /**
     * ROLE SYNCHRONIZATION:
     * Find the selected school object and update loginAs to match the user's role in that school.
     * This ensures that when switching between schools, the user's permissions match their
     * role in the currently selected school, not the role they originally logged in with.
     */
    const selectedSchool = this.schools.find(school => school.value == event);
    if (selectedSchool && selectedSchool.roles) {
      // Find the admin or manager role for this school (user should have one of these)
      const adminRole = selectedSchool.roles.find(role =>
        role.name === 'school_admin' || role.name === 'manager'
      );
      if (adminRole) {
        // Update both localStorage and component property to keep them in sync
        localStorage.setItem('loginAs', adminRole.name);
        this.loginAs = adminRole.name;
      }
    }

    // Navigate to dashboard and reload to apply the new school context
    // The reload ensures all components re-initialize with the new school and role
    this.router.navigate(['dashboard/students'])
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 50);
      });
  }

  getAllRequests() {
    let reqArray;
    switch (this.loginAs) {
        case 'school_admin':
          reqArray = [
            this.http.get(environment.url + `v2/user/schools`),
            this.http.get(environment.url + `users/${this.userId}`),
            this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/grades`),
            this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/gates`),
            // this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/routes`),
            // this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages?&per_page=25&page=1&sort[created_at]=desc`),
            this.http.get(environment.url + `v2/settings`),
            this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users?is_paginated=0`),
            this.http.get(environment.url + `v2/config-parameter/betaSchools`),
            // this.http.get(environment.url + `v2/config-parameter/cafeteria`),
            this.http.get(environment.url + `v2/config-parameter/BusBeta`),
            this.http.get(environment.url + `v2/schools/${localStorage.getItem("schoolId")}/grades/all-grades`),
            this.http.get(environment.url + `v2/config-parameter/betaCallingscreen`),
            this.http.get(environment.url + `v2/config-parameter/bulkUploadStudents`),
            this.http.get(environment.url + `v2/config-parameter/geminiVoiceWidget`),
            this.http.get(environment.url + `v2/config-parameter/pioneer_integration_flow`)
          ];
          break;
        case 'manager':
            reqArray = [
              this.http.get(environment.url + `v2/user/schools`),
              this.http.get(environment.url + `users/${this.userId}`),
              this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/grades`),
              this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/gates`),
              // this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/routes`),
              // this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/messages?&per_page=25&page=1&sort[created_at]=desc`),
              this.http.get(environment.url + `v2/settings`),
              this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users?is_paginated=0`),
              this.http.get(environment.url + `v2/config-parameter/betaSchools`),
              // this.http.get(environment.url + `v2/config-parameter/cafeteria`),
              this.http.get(environment.url + `v2/config-parameter/BusBeta`),
              this.http.get(environment.url + `v2/schools/${localStorage.getItem("schoolId")}/grades/all-grades`),
              this.http.get(environment.url + `v2/config-parameter/betaCallingscreen`),
              this.http.get(environment.url + `v2/config-parameter/bulkUploadStudents`),
              this.http.get(environment.url + `v2/config-parameter/geminiVoiceWidget`),
              this.http.get(environment.url + `v2/config-parameter/pioneer_integration_flow`)
            ];
          break;
      default:
        reqArray = [
          this.http.get(environment.url + `v2/user/schools`),
          this.http.get(environment.url + `users/${this.userId}`),
          this.http.get(environment.url + `v2/config-parameter/betaCallingscreen`),
          this.http.get(environment.url + `v2/config-parameter/gamificationCallingscreen`),
          this.http.get(environment.url + `v2/config-parameter/geminiVoiceWidget`)
          // this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/grades`),
          // this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/gates`),
          // this.userService.getProfile(this.userId)
        ];
        break;
    }

    if (this.dataService.allGrades == null) {
      this.globalService.startInitialLoading();
      forkJoin(reqArray).subscribe((Results: any) => {
        if (this.loginAs == "school_admin" || this.loginAs == "manager") {
          this.getSchools(Results[0]);
          this.dataService.setIsCallingScreenBeta$(Results[9]?.value?.Web?.school_ids.includes(+localStorage.getItem('schoolId')) || Results[9]?.value?.Web?.isForAll ? true : false);
        }
        if(this.loginAs == 'teacher' || this.loginAs == 'supervisor'){
          this.getSchoolsForObserver(Results[0]);
          this.dataService.setIsCallingScreenBeta$(Results[2]?.value?.Web?.school_ids.includes(+localStorage.getItem('schoolId')) || Results[2]?.value?.Web?.isForAll ? true : false);
          this.dataService.setIsCallingScreenGamification$(Results[3]?.value?.Web?.school_ids.includes(+localStorage.getItem('schoolId')) || Results[3]?.value?.Web?.isForAll ? true : false);
        }
        this.switchObserverMode(Results[1]);
        this.dataService.setAllGrades$(Results[2])
        this.dataService.setAllGates$(Results[3])
        // this.dataService.setAllRoutes$(Results[4])        
        
        /**
         * SCHOOL SELECTION FEATURE - STORE UNFILTERED SCHOOLS
         * 
         * Store the complete, unfiltered list of schools in the data service.
         * This is important because:
         * 1. We don't filter here - we store ALL schools the user has access to
         * 2. The getSchools() function will apply its own filtering (admin/manager roles)
         * 3. Other components may need access to all schools, not just filtered ones
         * 
         * Why no filter? Previously, we filtered by this.loginAs here, which caused issues:
         * - If user logged in as 'manager' but has 'school_admin' in another school,
         *   that school would be filtered out here
         * - But getSchools() needs to show all schools where user has admin/manager roles
         * - This mismatch caused the dropdown to show fewer schools than expected
         * 
         * By storing unfiltered schools, we let getSchools() handle the filtering logic
         * consistently, ensuring all relevant schools are available for selection.
         */
        this.dataService.setSchoolInfo$(Results[0])
        for (const key of this.currentUserKeys) {
          this.dataService.currentUser[key] = Results[1][key];
        }
        this.dataService.currentUser['role_type'] = Results[1].roles.find(role => role.name == localStorage.getItem('loginAs')).name;
        // this.dataService.setAllMesssages$(Results[5]);
        this.dataService.setHealthConditions$(Results[4]);
        this.dataService.setUsers$(Results[5]);
        this.dataService.setIsBeta$(Results[6]?.value?.Web?.school_ids.includes(+localStorage.getItem('schoolId')) ? true : false);
        // this.dataService.setIsCafeteria$(Results[7]?.value?.Web?.school_ids.includes(+localStorage.getItem('schoolId')) ? true : false);
        this.dataService.setIsBusBeta$(Results[7]?.value?.Web?.school_ids.includes(+localStorage.getItem('schoolId')) ? true : false);
        this.dataService.setV2Grades$(Results[8])
        this.dataService.setIsBulkUploadStudentsBeta$(Results[10]?.value?.Web?.school_ids.includes(+localStorage.getItem('schoolId')) || Results[10]?.value?.Web?.isForAll ? true : false);
        this.dataService.setIsGeminiVoiceWidget$(Results[11]?.value?.Web?.school_ids.includes(+localStorage.getItem('schoolId')) || Results[11]?.value?.Web?.isForAll ? true : false);
        this.dataService.setIsPioneerIntegrationFlow$(Results[12]?.value?.Web?.school_ids.includes(+localStorage.getItem('schoolId')) || Results[12]?.value?.Web?.isForAll ? true : false);

      }, (err => {

        switch (err.status) {
          case 403:
            this.globalService.stopInitialLoading();
            break;

          default:
            break;
        }
      }), () => {
        this.globalService.stopInitialLoading();

      });
    }
  }

  ngAfterViewInit() {
    if (this.enableVoiceCalling == false) {
      if (this.lng) {
        this.lng.nativeElement.setAttribute('disabled', '');
        this.lng.nativeElement.classList.add('opacity');
      }
    }
    if (this.statusCalling == 'ar') {
      // this.en.nativeElement.setAttribute('disabled', '');
      // this.en.nativeElement.classList.add('opacity');
      this.lngFlag = 'ar';
    }
    else if (this.statusCalling == 'en') {
      // this.ar.nativeElement.setAttribute('disabled', '');
      // this.ar.nativeElement.classList.add('opacity');
      this.lngFlag = 'en';

    }
    else {
      /* 
        check if status calling is anything but [(ar,en), ex:null] that means that cashe has been cleared , in this case:
        > set lang to Arabic as default to avoid user confussion 
        > button will show the word 'Arabic' rather than 'Language' to avoid user confussion 
      */
      this.lngFlag = 'ar';
      localStorage.removeItem('statusCalling')
      this.toggleVoiceStatus('ar')
    }
    this.loginAs == 'gate' ? this.openFullscreen() : '';
    // to remove console error Expression has changed after it was checked
    this.cdr.detectChanges();

    this.sideBarToggleState(null, 'init');
  }

  changeVoiceCalling() {
    let lngBtn = document.querySelector("#lng-btn");
    if (this.enableVoiceCalling) {
      localStorage.setItem('voiceCalling', 'true');
      lngBtn.removeAttribute('disabled');
      lngBtn.classList.remove('opacity');

    } else {
      localStorage.setItem('voiceCalling', 'false');
      lngBtn.setAttribute('disabled', '');
      lngBtn.classList.add('opacity');
    }
  }

  toggleVoiceStatus(lang: string) {
    switch (lang) {
      case 'en':
        // let arBtn = document.querySelector("#ar-btn");
        // arBtn.toggleAttribute("disabled");
        // arBtn.classList.toggle('opacity');
        //check if arabic btn has attribute disabled when clicking english btn that means that english btn is active  
        localStorage.setItem('statusCalling', 'en');
        this.lngFlag = 'en';
        //   if(arBtn.hasAttribute('disabled')){
        //     localStorage.setItem('statusCalling', 'en');
        //     // this flag to toggle the right tick of english language
        //     this.englishFlag= true;
        //   }  
        //  //check if arabic btn dosen't has attribute disabled when clicking english btn that means that english btn clicked again to deactivate   
        //   else{
        //     // in this case none of lang is selected so remove the status calling from localstorage 
        //     localStorage.removeItem('statusCalling')
        //     this.englishFlag= false;
        //   }   
        break;
      case 'ar':
        // let enBtn = document.querySelector("#en-btn");
        // enBtn.toggleAttribute("disabled");
        // enBtn.classList.toggle('opacity');
        //check if english btn has attribute disabled when clicking arabic btn that means that arabic btn is active
        localStorage.setItem('statusCalling', 'ar');
        this.lngFlag = 'ar';
        // if(enBtn.hasAttribute('disabled')){
        //   localStorage.setItem('statusCalling', 'ar');
        //  // this flag to toggle the right tick of arabic language
        //   this.arabicFlag = true;
        // }  
        // //check if english btn dosen't has attribute disabled when clicking arabic btn that means that arabic btn clicked again to deactivate   
        // else{
        //   // in this case none of lang is selected so remove the status calling from localstorage 
        //   localStorage.removeItem('statusCalling')
        //   this.arabicFlag = false;
        // }  
        break;
    }
  }

  setLoggedInUser(loggedInUser: string): string {
    let localizedLoggedInUser = '';
    switch (loggedInUser) {
        case 'school_admin':
          localizedLoggedInUser = this.translate.instant('roles.school_admin')
          break;
      case 'manager':
        localizedLoggedInUser = this.translate.instant('roles.manager')
        break;
      case 'teacher':
        localizedLoggedInUser = this.translate.instant('roles.teacher')
        break;
      case 'supervisor':
        localizedLoggedInUser = this.translate.instant('roles.supervisor')
        break;
      case 'security':
        localizedLoggedInUser = this.translate.instant('roles.security')
        break;
      case 'gate':
        localizedLoggedInUser = this.translate.instant('roles.gate')
        break;
      case 'cafeteria':
        localizedLoggedInUser = this.translate.instant('roles.cafeteria')
        break;
    }
    return localizedLoggedInUser
  }

  // temp
  toggleLang() {
    if (this.currLang == 'en') {
      this.globalService.setLang('ar');
      // this.translate.use('ar');
      this.currLang = 'ar';
      this.direction = 'rtl'

    } else {
      this.globalService.setLang('en');
      this.currLang = 'en';
      this.direction = 'ltr'
      // this.translate.use('en');
    }
    this.router.navigateByUrl(this.router.url)
  }
  async logOut() {
    // logging out signs out every open tab, so ask first when other tabs are signed in
    if (await this.tabSyncService.confirmLogout()) {
      this.userService.logOut();
    }
  }
  goBack() {
    // this.location.back();
    this.router.navigate(['dashboard/students'])
  }
  openProfile() {
    this.globalService.stopLoading();
    $("#profileModal").modal("show");
  }

  menuOpened() {
    $("#settings-btn").addClass("onclicked");
    $("#settings-btn svg").addClass('onSvgclicked');
    $("#settings-btn p").addClass('onPclicked');
  }
  menuClosed() {
    $("#settings-btn").removeClass("onclicked ");
    $("#settings-btn svg").removeClass('onSvgclicked');
    $("#settings-btn p").removeClass('onPclicked');
  }

  toggleColors(event, fileType) {
    const root = document.documentElement;
    switch (fileType) {
      case 'excel':
        if (event == "ready") {
          root.style.setProperty('--background-color', '#E6F7F0');
          root.style.setProperty('--text-color', '#46CEA2');
          root.style.setProperty('--width', '460px');
        } else if (event == "preparing") {
          root.style.setProperty('--background-color', '#e6f1f7');
          root.style.setProperty('--text-color', '#0074ec');
          root.style.setProperty('--width', '385px');
        }
        break;
      case 'qr':
        if (event == "ready") {
          root.style.setProperty('--background-color-qr', '#E6F7F0');
          root.style.setProperty('--text-color-qr', '#46CEA2');
          root.style.setProperty('--width-qr', '460px');

        } else if (event == "preparing") {
          root.style.setProperty('--background-color-qr', '#e6f1f7');
          root.style.setProperty('--text-color-qr', '#0074ec');
          root.style.setProperty('--width-qr', '385px');
        }
        break;
      case 'approveAll':
        if (event == "ready") {
          root.style.setProperty('--background-color-approveAll', '#E6F7F0');
          root.style.setProperty('--text-color-approveAll', '#46CEA2');
          root.style.setProperty('--width-approveAll', '460px');

        }
        else if (event == "preparing") {
          root.style.setProperty('--background-color-approveAll', '#e6f1f7');
          root.style.setProperty('--text-color-approveAll', '#0074ec');
          root.style.setProperty('--width-approveAll', '385px');
        }

        else if (event == "failed") {
          root.style.setProperty('--background-color-approveAll', '#F7E6E6');
          root.style.setProperty('--text-color-approveAll', '#F46363');
          root.style.setProperty('--width-approveAll', '460px');
        }

        break;
      case 'upload':
        if (event == "ready") {
          root.style.setProperty('--background-color-upload', '#E6F7F0');
          root.style.setProperty('--text-color-upload', '#46CEA2');
          root.style.setProperty('--width-upload', '460px');

        }
        else if (event == "preparing") {
          root.style.setProperty('--background-color-upload', '#e6f1f7');
          root.style.setProperty('--text-color-upload', '#0074ec');
          root.style.setProperty('--width-upload', '385px');
        }

        else if (event == "failed") {
          root.style.setProperty('--background-color-upload', '#F7E6E6');
          root.style.setProperty('--text-color-upload', '#F46363');
          root.style.setProperty('--width-upload', '460px');
        }

        break;

      case 'bus-bulk-enroll':
        if (event == "finished") {
          root.style.setProperty('--background-color-upload', '#E6F7F0');
          root.style.setProperty('--text-color-upload', '#46CEA2');
          root.style.setProperty('--width-upload', '460px');

        }
        else if (event == "uploading" || event == "enroll-in-progress") {
          root.style.setProperty('--background-color-upload', '#e6f1f7');
          root.style.setProperty('--text-color-upload', '#0074ec');
          root.style.setProperty('--width-upload', '385px');
        }

        else if (event == "finshed-with-errors") {
          root.style.setProperty('--background-color-upload', '#F7E6E6');
          root.style.setProperty('--text-color-upload', '#F46363');
          root.style.setProperty('--width-upload', '460px');
        }

        break;
      case 'bulk-students-update':
        if (event == "finished") {
          root.style.setProperty('--background-color-upload', '#E6F7F0');
          root.style.setProperty('--text-color-upload', '#46CEA2');
          root.style.setProperty('--width-upload', '500px');
        }
        else if (event == "uploading") {
          root.style.setProperty('--background-color-upload', '#e6f1f7');
          root.style.setProperty('--text-color-upload', '#0074ec');
          root.style.setProperty('--width-upload', '500px');
        }

        else if (event == "finshed-with-errors") {  
          root.style.setProperty('--background-color-upload', '#F7E6E6');
          root.style.setProperty('--text-color-upload', '#F46363');
          root.style.setProperty('--width-upload', '500px');
        }

        break;
      case 'bulk-students-import':
        if (event == "finished" || event == "processing_completed") {
          root.style.setProperty('--background-color-upload', '#E6F7F0');
          root.style.setProperty('--text-color-upload', '#46CEA2');
          root.style.setProperty('--width-upload', '500px');
        }
        else if (event == "uploading" || event == "processing_started") {
          root.style.setProperty('--background-color-upload', '#e6f1f7');
          root.style.setProperty('--text-color-upload', '#0074ec');
          root.style.setProperty('--width-upload', '500px');
        }
      default:
        break;
    }
  }

  cancelExport(e) {
    e.stopPropagation();
    this.globalService.setExportAlert('');
    // this.toggleExcel = null;
    this.excelFileUrl = '';
  }

  cancelPrint(e) {
    e.stopPropagation();
    this.globalService.setPrintQrAlert('');
    // this.toggleExcel = null;
    this.qrFileUrl = '';
  }

  cancelApproveAll(e) {
    e.stopPropagation();
    this.globalService.setApproveAllRequests('');
    // this.toggleExcel = null;
    // this.qrFileUrl = '';
  }

  cancelUpload(e) {
    e.stopPropagation();
    this.globalService.setUploadSheet('');
    // this.toggleExcel = null;
    // this.qrFileUrl = '';
  }

  cancelBusEnroll(e) {
    e.stopPropagation();
    this.globalService.setBusEnrollNotificationState('');
    this.toggleBusEnrollAlert = '';
    this.busEnrollFailedCount = 0;
    this.busEnrollSucessCount = 0;
  }

  cancelBulkBusEnroll(e) {
    e.stopPropagation();
    this.globalService.setBulkEnrollNotificationState('');
  }

  exportFile(e) {
    e.stopPropagation();
    this.globalService.setExportAlert('');
    // this.toggleExcel = null;
    this.excelFileUrl ? window.open(this.excelFileUrl, '_self') : '';
  }

  printQr(e) {
    e.stopPropagation();
    this.globalService.setPrintQrAlert('');
    this.qrFileUrl ? window.open(this.qrFileUrl, '_blank') : '';
  }

  veiwAllFailedRequest(e) {
    e.stopPropagation();
    let currentUrl = this.router.url;
    this.globalService.setApproveAllRequests('');
    if (currentUrl.split('/').pop() == "edit-requests") {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
    }
    else {
      this.router.navigateByUrl('dashboard/edit-requests');
    }
  }

  veiwAllFailedUpload(e) {
    e.stopPropagation();
    let currentUrl = this.router.url;
    this.globalService.setUploadSheet('');
    // this.globalService.setUploadErrorsUrl('');
    this.globalService.setUploadErrorsUrl(this.uploadErrorsUrl);
    switch (this.uploadType) {
      case 'school-students-import':
        if (currentUrl.split('/').pop() == "upload") {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
          });
        }
        else {
          this.router.navigateByUrl('dashboard/upload');
        }
        break;

      case 'school-users-import':
        if (currentUrl.split('/').pop() == "staff") {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
          });
        }
        else {
          this.router.navigateByUrl('school-management/staff');
        }
        break;

      default:
        break;
    }
    //   e.stopPropagation();
    //   let currentUrl = this.router.url;
    //   this.globalService.setApproveAllRequests('');
    //   if(currentUrl.split('/').pop()=="edit-requests"){
    //     this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
    //       this.router.navigate([currentUrl]);
    //   });   
    // }
    //   else{
    //   this.router.navigateByUrl('dashboard/edit-requests');
    //   }
  }

  
  openFullscreen() {

    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }
  /* Close fullscreen */
  closeFullscreen() {
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }

  @HostListener('document:dblclick', ['$event'])
  clickin() {
    this.loginAs == 'gate' ? this.openFullscreen() : '';
  }


  ngOnDestroy() {
    //console.log('(c)layout_(f)ngOnDestroy_(L)766');
    if (this.loginAs == 'gate') {
      this.closeFullscreen();
    }
  }

  /**
   * SCHOOL SELECTION FEATURE - PROCESS AND SELECT SCHOOLS
   * 
   * This function is the core of the school selection feature. It:
   * 1. Normalizes school data for the PrimeNG dropdown component
   * 2. Filters schools to show only those where user has admin/manager roles
   * 3. Selects the appropriate school (from localStorage or defaults to first)
   * 4. Updates loginAs to match the user's role in the selected school
   * 5. Stores school information in localStorage for persistence
   * 
   * FILTERING LOGIC:
   * - We filter by 'school_admin' OR 'manager' roles (not by logged-in role)
   * - This allows users to see all schools where they have admin privileges
   * - Example: User logged in as 'manager' but has 'school_admin' in School A
   *   → Both schools will appear in dropdown, allowing role switching
   * 
   * SELECTION LOGIC:
   * - Priority 1: Use lastShcoolSelectedId from localStorage (set during login or school change)
   * - Priority 2: Default to first school in filtered list
   * - This ensures consistent school selection across page reloads
   * 
   * ROLE SYNCHRONIZATION:
   * - When a school is selected, we update loginAs to match the user's role in that school
   * - This prevents permission mismatches when switching between schools
   * - The role update happens both here (on load/reload) and in onSelectionChange() (on manual selection)
   * 
   * @param schools - Array of school objects from the API, containing all schools user has access to
   */
  getSchools(schools) {
    let selectedSchool;
    let schoolsContainsAdminRole = []
    
    // Get the last selected school ID from localStorage (set during login or school selection)
    let lastSelectedId = localStorage.getItem('lastShcoolSelectedId')
    
    /**
     * STEP 1: NORMALIZE SCHOOL DATA
     * Transform the raw school objects into a format suitable for the PrimeNG dropdown.
     * Each school object is enhanced with dropdown-specific properties.
     */
    schools.forEach(school => {
      school.selected = false;
      school.value = school.id;
      school.label = school.name;
      school.schoolImage = school.image_path;
      school.latitude = school.lat;
      school.longitude = school.long;
      school.countryCode = school?.country_code
    })

    
    /**
     * STEP 2: FILTER SCHOOLS BY ADMIN/MANAGER ROLES
     * 
     * Filter to show only schools where the user has 'school_admin' OR 'manager' role.
     * This is different from login filtering which filters by the logged-in role.
     * 
     * Why this filter?
     * - The dropdown should only show schools where user has admin privileges
     * - A user may have different roles in different schools
     * - We want to show all schools where they can act as admin, regardless of login role
     * 
     * Example scenario:
     * - User logs in as 'manager' (has manager role in School B)
     * - User also has 'school_admin' role in School A
     * - This filter shows BOTH schools, allowing the user to switch between them
     */
    schoolsContainsAdminRole = schools.filter(school =>
      school.roles.some(role => role.name === 'school_admin' || role.name === 'manager')
    )

    // Store filtered schools for the dropdown component
    this.schools = schoolsContainsAdminRole;

    /**
     * STEP 3: SELECT THE APPROPRIATE SCHOOL
     * 
     * Selection priority:
     * 1. If lastShcoolSelectedId exists (set during login or previous selection):
     *    - Find and select that school from the filtered list
     *    - This restores the user's previous selection after page reload
     * 2. Otherwise (first time or no previous selection):
     *    - Default to the first school in the filtered list
     *    - This ensures a school is always selected
     */
    if (!!lastSelectedId) {
      // Restore previous selection
      selectedSchool = this.schools.find(school => school.value == lastSelectedId);
      // Reset all schools' selected flag before setting the new one
      this.schools.forEach(school => {
        school.selected = false;
      });
    }
    else {
      // Default to first school (typically happens on first login)
      selectedSchool = this.schools[0];
    }
    
    /**
     * STEP 4: SAFETY CHECK
     * Ensure we have a valid school before proceeding. This prevents runtime errors
     * if the filtered list is empty or if lastSelectedId points to a school that
     * no longer exists in the filtered list.
     */
    if (!selectedSchool) {
      console.error('No school found to select');
      return;
    }
    
    /**
     * STEP 5: UPDATE UI AND LOCALSTORAGE
     * Set the selected school's properties and store all relevant information
     * in localStorage for persistence and use by other components.
     */
    selectedSchool.selected = true;
    this.selectedSchool = selectedSchool.value;
    this.schoolName = selectedSchool.label;
    this.schoolImg = environment.img_url + selectedSchool.schoolImage;
    localStorage.setItem("schoolId", selectedSchool.id);
    localStorage.setItem('schoolImage', selectedSchool.schoolImage);
    localStorage.setItem('schoolName', selectedSchool.label)
    localStorage.setItem('schoolLat', selectedSchool.latitude)
    localStorage.setItem('schoolLong', selectedSchool.longitude)
    localStorage.setItem('schoolCountryCode', selectedSchool.countryCode)

    
    /**
     * STEP 6: ROLE SYNCHRONIZATION
     * 
     * CRITICAL: Update loginAs to match the user's role in the selected school.
     * 
     * Why this is necessary:
     * - User may have logged in with one role but selected a school where they have a different role
     * - Example: Logged in as 'manager' but selected School A where they're 'school_admin'
     * - The app's permission system relies on loginAs to determine access
     * - We must keep loginAs in sync with the selected school's role
     * 
     * This ensures:
     * - Correct permissions are applied for the selected school
     * - UI elements show/hide correctly based on role
     * - API calls include the correct role context
     * - No permission mismatches when switching schools
     */
    if (selectedSchool.roles) {
      // Find the admin or manager role for this school
      const adminRole = selectedSchool.roles.find(role => 
        role.name === 'school_admin' || role.name === 'manager'
      );
      if (adminRole) {
        // Update both localStorage and component property
        localStorage.setItem('loginAs', adminRole.name);
        this.loginAs = adminRole.name;
      }
    }
  }

  /**
   * SCHOOL SELECTION FEATURE - PROCESS AND SELECT SCHOOLS (TEACHER / SUPERVISOR)
   *
   * Sibling of getSchools() for the teacher/supervisor roles. It is deliberately kept
   * separate so the admin/manager flow stays byte-for-byte untouched. Two differences:
   *
   * 1. FILTER BY THE LOGGED-IN ROLE, NOT ADMIN/MANAGER
   *    The dropdown must list only the schools where the user holds the SAME role they
   *    logged in with. Example: a user who is 'teacher' in School A + School B and
   *    'school_admin' in School C, logged in as 'teacher', sees only A and B.
   *    (This matches the login-time filter in login.component.ts afterLoginProcess().)
   *
   * 2. NO ROLE SYNCHRONIZATION
   *    Because every listed school shares the current role, loginAs never needs to change
   *    when switching between them — so we do not write loginAs here.
   *
   * @param schools - Array of school objects from v2/user/schools (all schools the user can access)
   */
  getSchoolsForObserver(schools) {
    let selectedSchool;

    // Get the last selected school ID from localStorage (set during login or school selection)
    let lastSelectedId = localStorage.getItem('lastShcoolSelectedId')

    // STEP 1: NORMALIZE SCHOOL DATA for the PrimeNG dropdown (same shape as getSchools)
    schools.forEach(school => {
      school.selected = false;
      school.value = school.id;
      school.label = school.name;
      school.schoolImage = school.image_path;
      school.latitude = school.lat;
      school.longitude = school.long;
      school.countryCode = school?.country_code
    })

    // STEP 2: FILTER BY THE CURRENT LOGGED-IN ROLE (teacher OR supervisor)
    this.schools = schools.filter(school =>
      school.roles?.some(role => role.name === this.loginAs)
    )

    // STEP 3: SELECT THE APPROPRIATE SCHOOL (restore previous, else default to first)
    if (!!lastSelectedId) {
      selectedSchool = this.schools.find(school => school.value == lastSelectedId);
      this.schools.forEach(school => {
        school.selected = false;
      });
    }
    else {
      selectedSchool = this.schools[0];
    }

    // STEP 4: SAFETY CHECK
    if (!selectedSchool) {
      console.error('No school found to select');
      return;
    }

    // STEP 5: UPDATE UI AND LOCALSTORAGE (no loginAs write — role never changes here)
    selectedSchool.selected = true;
    this.selectedSchool = selectedSchool.value;
    this.schoolName = selectedSchool.label;
    this.schoolImg = environment.img_url + selectedSchool.schoolImage;
    localStorage.setItem("schoolId", selectedSchool.id);
    localStorage.setItem('schoolImage', selectedSchool.schoolImage);
    localStorage.setItem('schoolName', selectedSchool.label)
    localStorage.setItem('schoolLat', selectedSchool.latitude)
    localStorage.setItem('schoolLong', selectedSchool.longitude)
    localStorage.setItem('schoolCountryCode', selectedSchool.countryCode)
  }

  removeSpecialCharc(string) {
    if(string){
      string = string.replace(/[^a-zA-Z0-9]/g, '');
      return string.toLowerCase();
    }
  }

  sideBarToggleState(event, action) {
    this.sideBarWidth = localStorage.getItem('sideBarWidth');
    switch (action) {
      case 'toggle':
        if (!event) {
          localStorage.setItem('sideBarWidth', '70px');
          this.sideBarWidth = localStorage.getItem('sideBarWidth');
        }
        else {
          localStorage.setItem('sideBarWidth', '16.6%');
          this.sideBarWidth = localStorage.getItem('sideBarWidth');
        }
        break;
      case 'init':
        let width = localStorage.getItem('sideBarWidth');
        if (width) {
          this.sideBarWidth = width;
        }
        else {
          this.sideBarWidth = '16.6%'
        }
        break;
      default:
        this.sideBarWidth = '16.6%'
        break;
    }
  }

  amplitudeEventHandler(tab) {
    switch (tab) {
      case 'school info':
        this.amplitudesService.trackEvent('CTA.SchoolInfo', {})
        break;
      case 'dismissal time':
        this.amplitudesService.trackEvent('CTA.DismissalTime_Tab', {})
        break;
      case 'staff':
        this.amplitudesService.trackEvent('CTA.Staff_Tab', {})
        break;
      case 'grades & classes':
        this.amplitudesService.trackEvent('CTA.Grades&Classes_tab', {})
        break;
      default:
        break;
    }
  }

  switchObserverMode(res){
    if(this.loginAs == 'teacher' || this.loginAs == 'supervisor'){
      let observerMode = res?.schools[0]?.pivot?.observer_mode == 1 ? true:false;
      localStorage.setItem('observer_mode', JSON.stringify(observerMode));
    }else{
      localStorage.removeItem('observer_mode');
    }
  }

  
  viewEnrollDetails() {
    this.toggleBusEnrollAlert = '';
    this.globalService.setBusEnrollNotificationState('');
    if(this.busEnrollType == 'bulk'){
      this.globalService.setBulkEnrollNotificationState('not-uploading');
      this.router.navigateByUrl('/buses/bulk-enroll/fix-errors');
    }
    else {
      this.router.navigateByUrl('/buses/enroll-details');
    }
  }
  cancelEnrollAlert() {
    this.toggleBusEnrollAlert = '';
    this.globalService.setBusEnrollNotificationState('');
  }

  ViewUploadProgress(e) {
    e.stopPropagation();
    this.router.navigateByUrl('/buses/bulk-enroll/upload-file');
  }

  ViewEnrollProgress(e) {
    e.stopPropagation();
    this.router.navigateByUrl('/buses/bulk-enroll/fix-errors');
  }


  assignTrips(e) {
    e.stopPropagation();
    this.globalService.setBulkEnrollNotificationState('not-uploading');
    this.router.navigateByUrl('/buses/bulk-enroll/fix-errors');
  }

  goToFixErrorsProcessingEnroll(e) {
    e.stopPropagation()
    this.globalService.setAutoBusEnroll(true);
    this.globalService.setNotifyViewWithBulkEnrollState('enroll-in-progress');
    // this.globalService.setBulkEnrollNotificationState('not-uploading');
    this.router.navigateByUrl('/buses/bulk-enroll/fix-errors');
  }

  fixEnrollErrors(e) {
    e.stopPropagation()
    this.globalService.setBulkEnrollNotificationState('not-uploading');
    this.router.navigateByUrl('/buses/bulk-enroll/fix-errors');
  }

  ViewBulkStudentsUpdateProgress(e) {
    e.stopPropagation();
    this.router.navigateByUrl('/data-management/upload-file');
  }

  ViewBulkStudentsImportProgress(e) {
    e.stopPropagation();
    this.router.navigateByUrl('/data-management/import-files');
  }

  goToBulkStudentsImportReview(e) {
    e.stopPropagation();
    this.globalService.setBulkStudentsImportNotificationState('not-uploading');
    this.globalService.setNotifyViewWithBulkStudentImportState('not-uploading');
    this.router.navigateByUrl('/data-management/import-review');
  }
  goToBulkImportResults(e) {
    e.stopPropagation();
    this.globalService.setBulkStudentsImportNotificationState('not-uploading');
    this.globalService.setNotifyViewWithBulkStudentImportState('not-uploading');
    this.router.navigateByUrl('/data-management/import-student-results');
  }

  cancelBulkStudentsUpdate(e) {
    e.stopPropagation();
    this.bulkStudentsUpdateCompleted ? this.bulkStudentsUpdateCompleted = false : this.globalService.setBulkStudentsUpdateNotificationState('');
  }
  cancelBulkStudentsImport(e) {
    e.stopPropagation();
    this.globalService.setBulkStudentsImportNotificationState('');
  }

  // both "syncing" and "ready" point back to the same page — that's where the sync button and its modals live
  viewPioneerSyncProgress(e) {
    e.stopPropagation();
    this.router.navigateByUrl('/data-management/students');
  }

  viewPioneerSyncResults(e) {
    e.stopPropagation();
    this.router.navigateByUrl('/data-management/students');
  }

  cancelPioneerSyncAlert(e) {
    e.stopPropagation();
    // only hides the banner — a later completion event can still bring it back with 'ready',
    // same as cancelBulkStudentsImport does for the manual upload flow
    this.globalService.setPioneerSync({ state: 'idle' });
  }

  bulkStudentUpdateRealTimeHandler(result) {
    // console.log('bulk students update channel', result);
    let local_bulk_students_update_notification_state = 'not-uploading';
    if (result) {
      // the failed for all invalid students uploaded
      if (result?.event_type == "upload_completed" || (result?.event_type == "upload_failed" && result?.status =="failed")) {
        localStorage.setItem('currentBulkStudentsUpdateBatchId', result?.batch_id);
        if (result?.status_flags) {
          local_bulk_students_update_notification_state = result?.status_flags?.has_errors ? 'finshed-with-errors' : 'finished';
        }
        else {
          local_bulk_students_update_notification_state = 'not-uploading';
        }
        this.globalService.setBulkStudentsUpdateNotificationState(local_bulk_students_update_notification_state);
        this.globalService.setNotifyViewWithBulkStudentUpdateState(local_bulk_students_update_notification_state);
        this.globalService.setBulkStudentsUpdate(result);
      }
      else if (result?.event_type == "processing_completed" ) {
        this.toggleColors('finished', 'bulk-students-update');
        this.bulkStudentsUpdateCompleted = true;
        this.bulkStudentsSuccessCount = result?.additional_data?.results?.updated_students;
      }
    }
  }

  bulkStudentImportRealTimeHandler(result) {
    console.log('bulk student import real time handler', result);
    if (!result) {
      return;
    }

    const { event_type: eventType, status, batch_id: batchId } = result;

    // pioneer sync stages its file through the same import_type/pipeline, but it's a preview batch —
    // nothing is confirmed yet, so it shouldn't trigger the global "upload in progress/finished" banner.
    // Its own status is surfaced by the dedicated pioneer sync modal via the pioneer_sync_completed event.
    if (eventType == 'pioneer_sync_completed') {
      return;
    }

    // the file lands on the server before its columns are matched, so an upload_started event can
    // arrive while the admin is still on the match-columns screen - nothing is processing yet,
    // and flipping the global banner to "preparing" there would be wrong.
    if (eventType === 'upload_started' && this.router.url.indexOf('/data-management/import-column-mapping') !== -1) {
      this.globalService.setBulkStudentsImport(result);
      return;
    }

    if(eventType === 'upload_started') {
      this.globalService.setBulkStudentsImportNotificationState('uploading');
      this.globalService.setNotifyViewWithBulkStudentImportState('uploading');
    }
      else if ( eventType === 'upload_completed' || (eventType === 'upload_failed' && status === 'failed')) {
      if (batchId) {
        localStorage.setItem('currentBulkStudentsImportBatchId', batchId);
      }
      this.globalService.setBulkStudentsImportNotificationState('finished');
      this.globalService.setNotifyViewWithBulkStudentImportState('finished');
    } 
    else if(eventType === 'processing_completed') {
      this.globalService.setBulkStudentsImportNotificationState('processing_completed');
      this.globalService.setNotifyViewWithBulkStudentImportState('processing_completed');
    }
    else if(eventType === 'pending_business_errors') {
      this.globalService.setBulkStudentsImportNotificationState('not-uploading');
      this.globalService.setNotifyViewWithBulkStudentImportState('not-uploading');
    }
    else {
      this.globalService.setBulkStudentsImportNotificationState('not-uploading');
      this.globalService.setNotifyViewWithBulkStudentImportState('not-uploading');
    }

    this.globalService.setBulkStudentsImport(result);
  }
}



